import {DataSource} from "./dataSourceTypes";
import {minAudioFadeDuration} from "../utils/constants";
import {Event} from "./eventTypes";
import {Competition} from "./competitionTypes";
import plugin from "dayjs/plugin/duration";

export interface BaseDataJob {
    idJob?: string,
    name: string,
    llm_generation?: boolean,
    description: string,
    extraction_schedule: Date,
    job_base_folder: string,
    tag: string[],
    push_schedule?: Date,
    target: "clipping" | "highlights" | "subtitles",
    data_sources: {
        source: {
            id: string,
        }
        role: string,
    }[],
    tracks: {
        track: {
            id: string,
        }
        role: string,
    }[],
    opener: any,
    closer: any,
    hooks?: HookObject[],
    kafka_hook?: boolean,
}

export interface HookObject {
    social_account_id: string;
    team: string | null;
    key_moment_types: string[];
    post_type: string;
    id?: string;
    job_id?: string;
    methods?: string[];
    type?: string;
}

export interface OptionsJobForm {
    dataSources: DataSource[];
    optionsTag: string[];
    targetJob: string[];
    idEvent: string;
}


export interface EventOfInterest {
    key_moment: string
    start: number | "auto"
    end: number | "auto"
    replay: boolean
    included?: boolean,
    var: boolean,
    auto_publication?: boolean,
}

export const skills = {
    SKILL_PASS : 'SKILL_PASS',
    SKILL_TACKLE : 'SKILL_TACKLE',
    SKILL_SAVE : 'SKILL_SAVE',
    SKILL_SHOT : 'SKILL_SHOT',
    SKILL_CROSS : 'SKILL_CROSS',
    SKILL_DRIBBLING : 'SKILL_DRIBBLING',
    SKILL_GOOD_SKILL : 'SKILL_GOOD_SKILL',
    SKILL_GOAL : 'SKILL_GOAL',
    SKILL_ASSIST : 'SKILL_ASSIST',
    SKILL_HEAD : 'SKILL_HEAD',
    SKILL_SET_PIECE : 'SKILL_SET_PIECE',
    SKILL_GOAL_FRAME : 'SKILL_GOAL_FRAME'
}

export interface Settings {
    key_moment: string;
    start: number;
    end: number;
    included: boolean;
    replay: boolean;
    var: boolean;
    auto_publication?: boolean;
}

export interface DataJob extends BaseDataJob {
    events: {
        id: string
    }[];
    settings: {
        fade?: boolean,
        fade_duration?: number
        events_of_interest: EventOfInterest[],
        offset: number,
        skills: EventOfInterest[],
    },
}

export interface jobSSE extends BaseDataJob {
    id: string; // nell'SSE è obbligatorio
    status: "Running" | "Completed" | "Failed" | string;
    last_state_change?: string;
    created_at: string;
    updated_at: string;
    clip_computation: boolean;
    production_pixel_format: string;
    preview_pixel_format: string;
    production_bit_rate: string;
    preview_bit_rate: string;
    organization_id: string;
    type: string;
    highlights_settings: any[];
    // qui sovrascrivo rispetto a DataJob
    events: PlatformEvent[];
    settings: {
        aspect_ratio?: number;
        resolution?:string;
        pix_fmt?: string;
        video_content_id?: string
        input_video_type?: string;
    }
}


export interface PlatformEvent {
    id: string;
    name: string;
    description: string;
    type: string;
    data_sources: {
        id: string;
    }[];
    start_schedule: string; // ISO date string
    end_schedule: string; // ISO date string
    tags: string[];
    home_team: string;
    away_team: string;
    competition: Competition;
    matchday: number;
    home_line_up: Record<string, string[]>;
    away_line_up: Record<string, string[]>;
    opta_id: string;
    home_score: number;
    away_score: number;
    round_type: string;
    requested?: boolean;
}

